import { render, staticRenderFns } from "./Shifts&Families.vue?vue&type=template&id=67dc140b"
import script from "./Shifts&Families.vue?vue&type=script&lang=js"
export * from "./Shifts&Families.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports